export const scrollToElement = refName => {
  setTimeout(() => {
    let element = document.getElementById(refName)
    element.scrollIntoView({ behavior: 'smooth' })
  }, 200)
}



// WEBPACK FOOTER //
// ./src/utils/functions.js